import {BoardCardColor, BoardCardColorCoding, defaultDisplayItemsTypes, MyWorkViewDisplayItem} from "../model/@const";

export default class MyWorkViewSettings {

    public systemFields             : ID[]
    public inboxGroupByDay          : boolean
    public contentGroupByType       : boolean
    public itemViewBorderPosition   : BoardCardColorCoding
    public itemViewColor            : BoardCardColor
    public panelPosition            : any // ?????
    public displayItemsTypes        : MyWorkViewDisplayItem
    public collapsedGroups          : string[]

    // For calendar view
    public showOnlyWorkdays         : boolean
    public showWeekNumber           : boolean

    public showSomeday              : boolean
    public showInbox                : boolean
    public foldedColumns            : number[]

    constructor(values: any) {

        this.systemFields           = _.get(values, 'systemFields', ['project','from-user','priority'])
        this.inboxGroupByDay        = _.get(values, 'inboxGroupByDay', true)
        this.contentGroupByType     = _.get(values, 'contentGroupByType', true)

        this.itemViewBorderPosition = _.get(values, 'itemViewBorderPosition', BoardCardColorCoding.NONE)
        this.itemViewColor          = _.get(values, 'itemViewColor', BoardCardColor.STATUS)
        this.panelPosition          = _.get(values, 'panelPosition', 'left')

        this.displayItemsTypes      = _.get(values, 'displayItemsTypes', defaultDisplayItemsTypes)

        this.collapsedGroups        = _.get(values, 'collapsedGroups', [])

        this.showOnlyWorkdays       = _.get(values, 'showOnlyWorkdays', false)
        this.showWeekNumber         = _.get(values, 'showWeekNumber', false)

        this.showSomeday            = _.get(values, 'showSomeday', false)
        this.showInbox              = _.get(values, 'showInbox', false)

        this.foldedColumns          = _.get(values, 'foldedColumns', [0,0,0,0,0,0,0,0,0,0,0,0,0,0]); // 0 inbox 1 today 2 tomorow .... val 0 = not 1 = folded
    }

    toggleShowSomeday() {
        this.showSomeday = !this.showSomeday;

        if (this.showInbox) {
            this.showInbox = !this.showInbox;
        }
    }

    toggleShowInbox() {
        this.showInbox = !this.showInbox;

        if (this.showSomeday) {
            this.showSomeday = !this.showSomeday;
        }
    }

    toObject() {
        return {
            systemFields            : this.systemFields,
            inboxGroupByDay         : this.inboxGroupByDay,
            contentGroupByType      : this.contentGroupByType,
            displayItemsTypes       : this.displayItemsTypes,
            collapsedGroups         : this.collapsedGroups,
            itemViewBorderPosition  : this.itemViewBorderPosition,
            itemViewColor           : this.itemViewColor,
            panelPosition           : this.panelPosition,

            showOnlyWorkdays        : this.showOnlyWorkdays,
            showWeekNumber          : this.showWeekNumber,
            showSomeday             : this.showSomeday,
            showInbox               : this.showInbox,
            foldedColumns           : this.foldedColumns,
        }
    }
}
